<div class="w-full">
    <section class="flex justify-center">
        <div class=" w-full max-sm:my-8 px-4">
            <div class="mt-12 mb-4">
                <div class="flex flex-row pb-4 hover:cursor-pointer" routerLink="/dashboard">
                    <div class="mr-2">
                        <mat-icon svgIcon="heroicons_solid:arrow-left-circle" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="font-bold">
                        Go back to dashboard
                    </div>
                </div>
                <h1 class="md:text-4xl text-3xl font-extrabold text-primary">
                    Billing and statements
                </h1>
            </div>
            <hr>

            <fuse-card class="rounded-3xl shadow-none ">
                <div class="flex flex-row justify-center w-full space-x-4 mx-2">
                    <div class="flex flex-col text-center items-center">
                        <button mat-flat-button
                            class="rounded-full w-full    flex flex-row justify-center items-center gap-x-2 px-2"
                            (click)="selectButton('billing')"
                            [style.background]="selectedButton === 'billing' ? '#423473' : 'white'"
                            [style.color]="selectedButton === 'billing' ? 'white' : 'black'">
                            <mat-icon class="icon-size-5" color="primary"
                                [svgIcon]="selectedButton === 'billing' ? 'heroicons_solid:credit-card' : 'heroicons_outline:credit-card'">
                            </mat-icon>
                            Billing
                        </button>
                        <hr [hidden]="selectedButton !== 'billing'" class="w-[60px] sm:w-[130px] mt-2 border-primary">
                    </div>

                    <div class="flex flex-col text-center items-center">
                        <button mat-flat-button
                            class="rounded-full w-full  flex flex-row justify-center items-center gap-x-2 px-2 py-2"
                            (click)="selectButton('statements')"
                            [style.background]="selectedButton === 'statements' ? '#423473' : 'white'"
                            [style.color]="selectedButton === 'statements' ? 'white' : 'black'">
                            <mat-icon class="icon-size-5" color="primary"
                                [svgIcon]="selectedButton === 'statements' ? 'heroicons_solid:document-text' : 'heroicons_outline:document-text'">
                            </mat-icon>
                            Statements
                        </button>
                        <hr [hidden]="selectedButton !== 'statements'"
                            class="w-[60px] sm:w-[130px] mt-2 border-primary">
                    </div>

                    <div class="flex flex-col text-center items-center">
                        <button mat-flat-button
                            class="rounded-full w-full  flex flex-row justify-center items-center gap-x-2 px-2 py-2"
                            (click)="selectButton('invoices')"
                            [style.background]="selectedButton === 'invoices' ? '#423473' : 'white'"
                            [style.color]="selectedButton === 'invoices' ? 'white' : 'black'">
                            <mat-icon class="icon-size-5" color="primary"
                                [svgIcon]="selectedButton === 'invoices' ? 'heroicons_solid:document-check' : 'heroicons_outline:document-check'">
                            </mat-icon>
                            Invoices
                        </button>
                        <hr [hidden]="selectedButton !== 'invoices'" class="w-[60px] sm:w-[130px] mt-2 border-primary">
                    </div>
                </div>
            </fuse-card>


        </div>
    </section>

    <!---------------------------------------------------------------------------------------------------------------------------------->
    <!----------------------------------------------------------- BILLING -------------------------------------------------------------->
    <!---------------------------------------------------------------------------------------------------------------------------------->
    <section *ngIf="selectedButton == 'billing'" class="flex justify-center">
        <div class="w-full md:mx-24 mb-18 max-sm:mx-4">
            <app-payment-methods [checkoutProcessView]="false"></app-payment-methods>
        </div>
    </section>


    <!---------------------------------------------------------------------------------------------------------------------------------->
    <!----------------------------------------------------------- INVOICES ----------------------------------------------------------->
    <!---------------------------------------------------------------------------------------------------------------------------------->
    <section *ngIf="selectedButton == 'invoices'" class="flex flex-col justify-center md:mx-24 mb-18 max-sm:mx-4">
        <div class="m-2">
            <!-- <div class="flex p-4 justify-center">
                <h1 class="font-semibold text-2xl text-primary">Invoices</h1>
            </div> -->
            

            <table *ngIf="pagedInvoices?.length >= 1"
                class="table-fixed md:table-auto w-full overflow-scroll justify-center items-center border-collapse border-spacing-4">
                <thead>
                    <tr class="text-sm lg:text-lg border-b-2">
                        <th class="px-5">Invoice Date</th>
                        <th class="px-5">Amount Due</th>
                        <th class="px-5">Status</th>
                        <th class="px-5">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b text-sm text-center md:text-md" *ngFor="let i of pagedInvoices">
                        <td class="p-5">{{i.DocumentDate | date : 'longDate'}}</td>
                        <td class="p-5">{{i.AmountDue | currency : 'R'}}</td>
                        <td class="p-5 font-bold" [ngClass]="{
                            'text-green-600': isPaid(i),
                            'text-yellow-500': isPending(i),
                            'text-red-600': isOverdue(i)
                          }">
                          <p>
                            {{ getStatusLabel(i) }}
                          </p>    
                        </td>
                        <td class="p-5 flex flex-row justify-around items-center">
                            <div class="flex flex-row space-x-2 items-center">
                                <div class="lg:w-[130px] w-10 h-[40px] flex items-center justify-center">
                                    <ng-container *ngIf="i.AmountDue >= 1">
                                        <button [routerLink]="['/balances']"
                                            class="rounded-full flex flex-row space-x-2 bg-accent text-primary p-2 hover:cursor-pointer">
                                            <span *ngIf="!isScreenSmall" class="font-semibold">Pay Now</span>
                                            <span *ngIf="isScreenSmall" class="font-semibold">Pay</span>
                                        </button>
                                    </ng-container>
                                </div>
                                <div class="w-[24px] h-[24px] flex items-center justify-center">
                                    <mat-icon *ngIf="!loadingMap[i.DocumentID]" (click)="downloadDocument(i, 'invoice', 'DocumentID', this._sharedMethods.getInvoiceById)"  
                                        class="icon-size-5 hover:cursor-pointer" color="primary"
                                        [svgIcon]="'heroicons_outline:arrow-down-tray'">
                                    </mat-icon>

                                    <mat-progress-spinner *ngIf="loadingMap[i.DocumentID]" [diameter]="24"
                                        mode="indeterminate" strokeWidth="3">
                                    </mat-progress-spinner>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="pagedInvoices?.length < 1" class="flex justify-center">
                <h1  class="font-semibold">
                  {{ hideViewMore ? 'No invoices found for this date range' : 'No invoices could be found on your account!' }}
                </h1>
            </div>
  
            <div class="flex flex-row items-center w-full relative mt-6" *ngIf="invoices?.length >= 1">
                <!-- Centered View More / Show Less -->
                <div class="flex justify-center w-full lg:absolute left-0 right-0">
                    <div *ngIf="invoices?.length > 6 && !hideViewMore">
                        <button mat-flat-button *ngIf="!isExpanded"
                            (click)="setPagedInvoices(0, invoices.length); isExpanded = true"
                            class="bg-accent">
                            View More
                        </button>
                        <button mat-flat-button *ngIf="isExpanded"
                            (click)="setPagedInvoices(0, 6); isExpanded = false"
                            class="bg-accent">
                            Show Less
                        </button>
                    </div>
                </div>
            
    
                <!-- <div class="ml-auto">
                    <mat-date-range-input [rangePicker]="picker" class="absolute opacity-0 pointer-events-none">
                        <input matStartDate placeholder="Start date" #dateRangeStart>
                        <input matEndDate placeholder="End date" #dateRangeEnd
                            (dateChange)="filterInvoicesStatements(dateRangeStart, dateRangeEnd, 'invoices')">
                    </mat-date-range-input>
            
                    <button (click)="picker.open()" class=" bg-secondary text-black" mat-flat-button *ngIf="!hideViewMore">
                        Search by Date Range
                    </button>
    
                    <button (click)="clearDateRange()" class=" bg-accent text-black" mat-flat-button *ngIf="hideViewMore"> 
                        Clear Date Range
                    </button>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </div> -->
            </div>
        </div>
    </section>

    <!---------------------------------------------------------------------------------------------------------------------------------->
    <!----------------------------------------------------------- STATEMENTS ----------------------------------------------------------->
    <!---------------------------------------------------------------------------------------------------------------------------------->
    <section *ngIf="selectedButton == 'statements'" class="flex flex-col justify-center md:mx-24 mb-18 max-sm:mx-4">

        <!-- <div class="flex justify-start">
            <button (click)="picker.open()"class="mt-2 text-lg bg-accent" mat-flat-button>Generate statement
                <div class="hidden">
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Start date" #dateRangeStart>
                        <input matEndDate placeholder="End date" #dateRangeEnd (dateChange)="addEvent(dateRangeStart, dateRangeEnd)">
                      </mat-date-range-input>
                </div>
            </button>

            <mat-date-range-picker #picker></mat-date-range-picker>

        </div> -->

        <div class="flex justify-end" *ngIf="!loadingStatements">
            <mat-form-field class="w-full md:w-1/5" appearance="outline">
                <mat-select class="w-full" placeholder="Filter by age (months)" (selectionChange)="onStatementChange($event)">
                    <mat-option value="currentMonth">Month to date</mat-option>
                    <mat-option value="lastMonth">Last month</mat-option>
                    <mat-option value="0-3Months">0 - 3 months</mat-option>
                    <mat-option value="3-6Months">3 - 6 months</mat-option>
                    <mat-option value="6-12Months">6 - 12 months</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class=" flex m-2 justify-center">
            <table *ngIf="pagedStatements?.length >= 1 && !loadingStatements"
                class="table-fixed md:table-auto w-full overflow-scroll justify-center items-center">
                <thead>
                    <tr class="text-sm md:text-lg border-b-2">
                        <th class="px-5">Statement Period</th>
 
                        <th class="px-5">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b text-sm text-center md:text-md" *ngFor="let i of pagedStatements">
                        <td class="p-5">{{i.ToDate | date : 'longDate'}} - {{i.FromDate | date : 'longDate'}}</td>
                        <td class="p-5 flex flex-row justify-around items-center">
                            <div class="flex flex-row space-x-2 items-center">
                                <!-- Always visible container to reserve space -->
                                <div class="w-[24px] h-[24px] flex items-center justify-center">
                                    <mat-icon *ngIf="!loadingMap[i.EntityAccountStatementHistoryID]" (click)="downloadDocument(i, 'statement', 'EntityAccountStatementHistoryID', this._sharedMethods.downloadStatement)"  
                                        class="icon-size-5 hover:cursor-pointer" color="primary"
                                        [svgIcon]="'heroicons_outline:arrow-down-tray'">
                                    </mat-icon>

                                    <mat-progress-spinner *ngIf="loadingMap[i.EntityAccountStatementHistoryID]" [diameter]="24"
                                        mode="indeterminate" strokeWidth="3">
                                    </mat-progress-spinner>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="loadingStatements">
                <mat-progress-spinner [diameter]="24" mode="indeterminate" strokeWidth="3">
            </mat-progress-spinner>
            </div>
            <div *ngIf="pagedStatements?.length < 1">
                <h1  class="font-semibold">
                  {{ hideViewMore ? 'No statements found for this date range' : 'No statements could be found on your account!' }}
                </h1>
            </div>
        </div>

        <div class="flex flex-row items-center w-full relative mt-4" *ngIf="statements?.length >= 1 && !loadingStatements">
            <div class="flex justify-center w-full lg:absolute left-0 right-0">
                <div *ngIf="statements?.length > 6 && !hideViewMore">
                    <button mat-flat-button *ngIf="!isExpanded"
                        (click)="setPagedStatements(0, statements.length); isExpanded = true"
                        class="bg-accent">
                        View More
                    </button>
                    <button mat-flat-button *ngIf="isExpanded"
                        (click)="setPagedStatements(0, 6); isExpanded = false"
                        class="bg-accent">
                        Show Less
                    </button>
                </div>
            </div>
           
        </div>
        
    </section>
</div>

<ng-template #viewPDFModal class="relative overflow-hidden">

    <mat-icon (click)="closeDialog()" class="icon-size-5 hover:cursor-pointer absolute top-0 right-0 m-2" color="warn"
        [svgIcon]="'heroicons_outline:x-mark'">
    </mat-icon>

    <ngx-doc-viewer *ngIf="!pdfLoading" class="pt-2" [url]="documentLink" viewer="url" style="width:100%;height:100%;">
    </ngx-doc-viewer>

    <div *ngIf="pdfLoading" class="w-full h-full flex justify-center items-center">
        <mat-progress-spinner *ngIf="pdfLoading" [diameter]="50" [mode]="'indeterminate'" [color]="primary">
        </mat-progress-spinner>
    </div>
</ng-template>